import {Outlet, useParams} from "react-router-dom"
import {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";
import TopNavBar from "../../components/TopNavBar";


export default function ProjectTopNav() {

    const {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const {prjid} = useParams()

    const [projName, setProjName] = useState<any>('')

    useEffect(() => {
        getProjName()
    }, [])

    let getProjName = async () => {
        let response = await fetch(`${serverIP}/getprjname/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({projPK: prjid}),
        })
        let data = await response.json()

        if (response.status === 200 && !projName) {
            setProjName(data.projName)
        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const topNavItems = [
        // {'name': projName, 'link': '#'},
        {'name': 'Project stats', 'link': 'details'},
        {'name': 'Map Fields', 'link': 'fields/1'},
        {'name': 'Map Specs', 'link': 'feats/1'},
        // {'name': 'Map Generics', 'link': 'gens/1'},
        {'name': 'Products', 'link': 'prods/1'},
        {'name': 'Reports', 'link': 'reports'},
        {'name': 'Templates', 'link': '../templates/1'}
    ]

    return (
        <>
            {projName &&    // a page is not loaded until Project Name is fetched
                <>
                    <TopNavBar user={user} logoutUser={logoutUser} projName={projName} topNavItems={topNavItems}/>

                    <Outlet/>
                </>
            }
        </>
    )
}